var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27138 0.75C13.9701 0.75 17.7921 4.572 17.7921 9.27075C17.7921 11.4876 16.9414 13.5095 15.5492 15.0269L18.2886 17.7606C18.545 18.017 18.5459 18.4317 18.2895 18.6881C18.1617 18.8176 17.9929 18.8815 17.8249 18.8815C17.6577 18.8815 17.4897 18.8176 17.3611 18.6899L14.5886 15.9251C13.1302 17.0931 11.281 17.7924 9.27138 17.7924C4.57263 17.7924 0.749756 13.9695 0.749756 9.27075C0.749756 4.572 4.57263 0.75 9.27138 0.75ZM9.27138 2.0625C5.29626 2.0625 2.06226 5.29563 2.06226 9.27075C2.06226 13.2459 5.29626 16.4799 9.27138 16.4799C13.2456 16.4799 16.4796 13.2459 16.4796 9.27075C16.4796 5.29563 13.2456 2.0625 9.27138 2.0625Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.420f10eaa602f1ac386eca591e6bf9c2.svg";
export { ForwardRef as ReactComponent };